
import React from 'react';
import {HeadFC, HeadProps} from 'gatsby';

import {defaultTags} from './metas';

// PageProps implements what we expect to be passed
// into creating the specific page
type PageProps = {
	data?: unknown,
	pageContext?: unknown,
};

type HeadResult = {
	title: string,
	canonical?: string,
	schema?: string,

	meta?: {
		name: string,
		property: string,
		content: string,
	}[],

	custom?: React.ReactNode,
}

// HeadFunc transforms properties from Gatsby
// into specific values that we use to render
// a standard <head /> block
type HeadFunc<T extends PageProps> = (
	(props: HeadProps<T['data'], T['pageContext']>) => HeadResult
);

export function PageHead<T extends PageProps>(fn: HeadFunc<T>): HeadFC<T> {
	const chref = (link: string) => {
		return `https://${process.env.GATSBY_WEB_EXTERNAL}${link}`;
	};

	const Head: HeadFC = (props) => {
		const head = fn(props);
		return (
			<>
				<title>{`${head.title} | BodySpec`}</title>

				{head.canonical && (
					<link rel='canonical' href={chref(head.canonical)} />
				)}

				{(head.meta || defaultTags()).map((props, i) => (
					<meta {...props} key={i} />
				))}

				{head.schema && (
					<script
						type='application/ld+json'
						dangerouslySetInnerHTML={{__html: head.schema}}
					/>
				)}

				{head.custom}
			</>
		);
	};

	return Head;
}
